import React, { useEffect, useState } from 'react'

import type { DragEndEvent } from '@dnd-kit/core'
import {
  DndContext,
  KeyboardSensor,
  MouseSensor,
  PointerSensor,
  closestCenter,
  useSensor,
  useSensors,
} from '@dnd-kit/core'
import {
  SortableContext,
  rectSortingStrategy,
  sortableKeyboardCoordinates,
} from '@dnd-kit/sortable'
import { Loading } from '@fourthwall/components'
import { arrayMove } from '@fourthwall/utils/dist/array'

import { usePerksContext } from '../../hooks/usePerksContext'
import { Perk } from '../Perk'
import * as S from './styled'

export const Perks = () => {
  const { perks, sortPerk, isLoading } = usePerksContext()

  const [innerPerks, setInnerPerks] = useState(perks)

  useEffect(() => {
    setInnerPerks(perks)
  }, [perks])

  const sensors = useSensors(
    useSensor(MouseSensor),
    useSensor(PointerSensor),
    useSensor(KeyboardSensor, {
      coordinateGetter: sortableKeyboardCoordinates,
    }),
  )

  if (!innerPerks)
    return (
      <div style={{ height: 48 }}>
        <Loading isLoading size="medium" />
      </div>
    )

  const handleDragEnd = ({ active, over }: DragEndEvent) => {
    const oldIndex = innerPerks.findIndex((perk) => perk.id === active.id)
    const newIndex = innerPerks.findIndex((perk) => perk.id === over?.id)

    if (newIndex < 0) return
    if (newIndex === oldIndex) return

    setInnerPerks(arrayMove([...innerPerks], oldIndex, newIndex))
    sortPerk(innerPerks[oldIndex].id, oldIndex, newIndex)
  }

  return (
    <Loading isLoading={isLoading} size="medium">
      <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleDragEnd}>
        <SortableContext items={innerPerks} strategy={rectSortingStrategy}>
          <S.PerksContainer>
            {innerPerks.map((perk, index) => (
              <S.PerkContainer key={index}>
                <S.Placeholder />
                <Perk perk={perk} />
              </S.PerkContainer>
            ))}
          </S.PerksContainer>
        </SortableContext>
      </DndContext>
    </Loading>
  )
}
